import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { FromTo } from '../../containers/Summary/TicketDetail';
import { getProp } from '../../utilities';
import DestinationFromTo from '../DestinationFromTo';
import Icon from '../Icon';

const Wrapper = styled.div`
  flex-direction: column;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: ${rem(13)} ${rem(30)};
  align-items: center;
  border-top: ${rem(1)} solid ${({ theme }) => theme.color.base};
  justify-content: space-between;
  ${({ theme }) => theme.media.sm`
    flex-direction: row;  
  `};
`;

const Flex = styled.div`
  display: flex;
`;

const Content = styled.div`
  background-color: ${({ color, theme }) =>
    color === 'primary' ? theme.color.font.primary : `#${color}`};
  border-radius: ${({ theme }) => theme.borderRadius};
`;

const Seats = styled.div`
  color: ${({ theme }) => theme.color.font.secondary};
  display: flex;
  letter-spacing: 0.2px;
  align-items: center;
  span {
    margin-right: ${rem(5)};
  }
`;

class SeatingTable extends PureComponent {
  constructor(props) {
    super(props);
    this.renderRow = this.renderRow.bind(this);
  }
  renderRow(item) {
    const { from_bus_stop: from, to_bus_stop: to, seatings } = item;
    // busInfo: { vehicle, owner }
    if (seatings) {
      return (
        <Wrapper>
          <Flex>
            <Icon name="bus" size="l" color="#db173f" />
            <FromTo>
              <DestinationFromTo from={from} to={to} font={16} />
            </FromTo>
          </Flex>
          <Seats>
            <Icon name="seatings" size="m" color="#a6a6a6" />
            {seatings.join(', ')}
          </Seats>
        </Wrapper>
      );
    }
    return null;
  }

  render() {
    return (
      <Content color={this.props.color}>
        {getProp(this.props, ['seatings'], []).map(this.renderRow)}
      </Content>
    );
  }
}

SeatingTable.defaultProps = {
  color: 'white',
};

SeatingTable.propTypes = {
  color: PropTypes.string.isRequired,
  seatings: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
};

export default SeatingTable;



// WEBPACK FOOTER //
// ./src/components/SeatingTable/index.js